import { Iso3166Alpha2, PhoneCountryCodes, allPhoneCountryCodes, extraCountryCodes, countryFlags } from "../types/countries";
import { OptionProps } from "../components/controls/Select"
import { getLocale, t } from "../i18n"

export const counties = [
  "",
  "Harjumaa",
  "Hiiumaa",
  "Ida-Virumaa",
  "Järvamaa",
  "Jõgevamaa",
  "Lääne-Virumaa",
  "Läänemaa",
  "Pärnumaa",
  "Põlvamaa",
  "Raplamaa",
  "Saaremaa",
  "Tartumaa",
  "Valgamaa",
  "Viljandimaa",
  "Võrumaa",
]

export const countyOptions: OptionProps[] = counties.map(county => ({ name: county, value: county }));

export const frequentlyChosenCountries = ["EE", "FI", "LT", "LV", "RU"];

const phoneCodes: Record<PhoneCountryCodes, string> = {
  AD: "+376",
  AE: "+971",
  AF: "+93",
  AL: "+355",
  AM: "+374",
  AO: "+244",
  AR: "+54",
  AT: "+43",
  AU: "+61",
  AW: "+297",
  AZ: "+994",
  BA: "+387",
  BD: "+880",
  BE: "+32",
  BF: "+226",
  BG: "+359",
  BH: "+973",
  BI: "+257",
  BJ: "+229",
  BN: "+673",
  BO: "+591",
  BR: "+55",
  BT: "+975",
  BW: "+267",
  BY: "+375",
  BZ: "+501",
  CD: "+243",
  CF: "+236",
  CG: "+242",
  CH: "+41",
  CI: "+225",
  CK: "+682",
  CL: "+56",
  CM: "+237",
  CN: "+86",
  CO: "+57",
  CR: "+506",
  CU: "+53",
  CV: "+238",
  CW: "+599",
  CY: "+357",
  CZ: "+420",
  DE: "+49",
  DJ: "+253",
  DK: "+45",
  DZ: "+213",
  EC: "+593",
  EE: "+372",
  EG: "+20",
  ER: "+291",
  ES: "+34",
  ET: "+251",
  FI: "+358",
  FJ: "+679",
  FK: "+500",
  FM: "+691",
  FO: "+298",
  FR: "+33",
  GA: "+241",
  GB: "+44",
  GE: "+995",
  GF: "+594",
  GH: "+233",
  GI: "+350",
  GL: "+299",
  GM: "+220",
  GN: "+224",
  GP: "+590",
  GQ: "+240",
  GR: "+30",
  GT: "+502",
  GW: "+245",
  GY: "+592",
  HK: "+852",
  HM: "+",
  HN: "+504",
  HR: "+385",
  HT: "+509",
  HU: "+36",
  ID: "+62",
  IE: "+353",
  IL: "+972",
  IN: "+91",
  IO: "+246",
  IQ: "+964",
  IR: "+98",
  IS: "+354",
  IT: "+39",
  JO: "+962",
  JP: "+81",
  KE: "+254",
  KG: "+996",
  KH: "+855",
  KI: "+686",
  KM: "+269",
  KP: "+850",
  KR: "+82",
  KW: "+965",
  LA: "+856",
  LB: "+961",
  LI: "+423",
  LK: "+94",
  LR: "+231",
  LS: "+266",
  LT: "+370",
  LU: "+352",
  LV: "+371",
  LY: "+218",
  MA: "+212",
  MC: "+377",
  MD: "+373",
  ME: "+382",
  MG: "+261",
  MH: "+692",
  MK: "+389",
  ML: "+223",
  MM: "+95",
  MN: "+976",
  MO: "+853",
  MQ: "+596",
  MR: "+222",
  MT: "+356",
  MU: "+230",
  MV: "+960",
  MW: "+265",
  MX: "+52",
  MY: "+60",
  MZ: "+258",
  NA: "+264",
  NC: "+687",
  NE: "+227",
  NF: "+672",
  NG: "+234",
  NI: "+505",
  NL: "+31",
  NO: "+47",
  NP: "+977",
  NR: "+674",
  NU: "+683",
  NZ: "+64",
  OM: "+968",
  PA: "+507",
  PE: "+51",
  PF: "+689",
  PG: "+675",
  PH: "+63",
  PK: "+92",
  PL: "+48",
  PM: "+508",
  PS: "+970",
  PT: "+351",
  PW: "+680",
  PY: "+595",
  QA: "+974",
  RO: "+40",
  RS: "+381",
  RU: "+7",
  RW: "+250",
  SA: "+966",
  SB: "+677",
  SC: "+248",
  SD: "+249",
  SE: "+46",
  SG: "+65",
  SH: "+290",
  SI: "+386",
  SK: "+421",
  SL: "+232",
  SM: "+378",
  SN: "+221",
  SO: "+252",
  SR: "+597",
  SS: "+211",
  ST: "+239",
  SV: "+503",
  SY: "+963",
  SZ: "+268",
  TD: "+235",
  TF: "+262",
  TG: "+228",
  TH: "+66",
  TJ: "+992",
  TK: "+690",
  TL: "+670",
  TM: "+993",
  TN: "+216",
  TO: "+676",
  TR: "+90",
  TV: "+688",
  TW: "+886",
  TZ: "+255",
  UA: "+380",
  UG: "+256",
  US: "+1",
  UY: "+598",
  UZ: "+998",
  VE: "+58",
  VN: "+84",
  VU: "+678",
  WF: "+681",
  WS: "+685",
  YE: "+967",
  ZA: "+27",
  ZM: "+260",
  ZW: "+263",
}

const addressCountries: Iso3166Alpha2[] = [...allPhoneCountryCodes, ...extraCountryCodes];

interface NamedOption {
  name: string;
  value: string;
}

interface PhoneOption extends NamedOption {
  value: PhoneCountryCodes;
}

const digiAuthBorrowerCountries: PhoneCountryCodes[] = ["EE"]

const digiAuthInvestorCountries: PhoneCountryCodes[] = ["EE"]

const getPhoneOptionName = (code: PhoneCountryCodes) => {
  return `${countryFlags[code]} ${phoneCodes[code]}`;
}

const makePhoneOption = (code: PhoneCountryCodes): PhoneOption => ({ name: getPhoneOptionName(code), value: code });

const byPhoneCode = (opt1: PhoneOption, opt2: PhoneOption): number => {
  return phoneCodes[opt1.value] > phoneCodes[opt2.value] ? 1 : -1;
}

const byName = (opt1: NamedOption, opt2: NamedOption): number => (opt1.name > opt2.name ? 1 : -1)

export type PhoneCodeOptionKey = "all" | "borrowerDigiAuth" | "investorDigiAuth"

export const phoneCodeOptions: Record<PhoneCodeOptionKey, PhoneOption[]> = {
  all: allPhoneCountryCodes.map(makePhoneOption).sort(byPhoneCode),
  borrowerDigiAuth: digiAuthBorrowerCountries.map(makePhoneOption).sort(byPhoneCode),
  investorDigiAuth: digiAuthInvestorCountries.map(makePhoneOption).sort(byPhoneCode),
}

export const makeCountryOption = (c: Iso3166Alpha2): NamedOption => ({ name: t(`countries.${c}`), value: c });

const countryOptions: Record<string, OptionProps[]> = {}

const borrowerCountryOptions: Record<string, OptionProps[]> = {
}

export const getBorrowerCountryOptions = (): OptionProps[] => {
  const locale = getLocale();
  if (!borrowerCountryOptions[locale]) {
    borrowerCountryOptions[locale] = [makeCountryOption("EE")];
  }
  return borrowerCountryOptions[locale];
}

export const getCountryOptions = (
  countries: Iso3166Alpha2[] = addressCountries, prefix: string = ""
): OptionProps[] => {
  const optionKey = prefix + getLocale();
  if (!countryOptions[optionKey]) {
    countryOptions[optionKey] = countries.map(makeCountryOption).sort(byName);
  }
  return countryOptions[optionKey];
}

export const extraCountryOptions = [
  {i18nKey: "loan.extra_country_options.other", value: "other"},
  {i18nKey: "loan.extra_country_options.without_citizenship", value: "undefined"}
];
